"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GisClient = void 0;
const BaseClient_1 = require("../BaseClient");
class GisClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    async getArcgisToken() {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/gis/arcgisToken',
        });
        return response.data;
    }
    /**
     * The findAddressCandidates operation geocodes one location per request.
     * @param requestParams
     *
     * @see https://developers.arcgis.com/rest/geocode/api-reference/geocoding-find-address-candidates.htm
     *
     * @example findAddressCandidates({ singleLine: '380 New York St, Redlands' });
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async findAddressCandidates(requestParams) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/gis/findAddressCandidates',
            params: requestParams,
        });
        return response.data;
    }
    /**
     * The reverseGeocode operation determines the address at a particular x,y location.
     * @param requestParams
     *
     * @see https://developers.arcgis.com/rest/geocode/api-reference/geocoding-reverse-geocode.htm
     *
     * @example reverseGeocode({ location: '-79.387065,43.642582' });
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async reverseGeocode(requestParams) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/gis/reverseGeocode',
            params: requestParams,
        });
        return response.data;
    }
    /**
     * Returns a list of suggestions.
     * @param requestParams
     *
     * @see https://developers.arcgis.com/rest/geocode/api-reference/geocoding-suggest.htm
     *
     * @example suggest({ text: 'New Y' });
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async suggest(requestParams) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/gis/suggest',
            params: requestParams,
        });
        return response.data;
    }
}
exports.GisClient = GisClient;
